"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRoomShareTokensView = exports.ListRoomShareTokensExpires = exports.RoomsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class RoomsApi extends runtime.BaseAPI {
    /**
     * Upload external audio to overwrite Streem-recorded audio in recordings
     * Upload external audio
     */
    acceptExternalAudioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling acceptExternalAudio.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/artifacts/external-audio`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiAcceptExternalAudioRequestToJSON)(requestParameters.streemApiAcceptExternalAudioRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiAcceptExternalAudioResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Upload external audio to overwrite Streem-recorded audio in recordings
     * Upload external audio
     */
    acceptExternalAudio(roomSid, streemApiAcceptExternalAudioRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acceptExternalAudioRaw({ roomSid: roomSid, streemApiAcceptExternalAudioRequest: streemApiAcceptExternalAudioRequest });
            return yield response.value();
        });
    }
    /**
     * Mark invitation as answered by invitee
     * Accept Invitation
     */
    acceptRoomInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling acceptRoomInvitation.');
            }
            if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
                throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling acceptRoomInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/accept`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiAcceptRoomInvitationRequestToJSON)(requestParameters.streemApiAcceptRoomInvitationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiAcceptRoomInvitationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Mark invitation as answered by invitee
     * Accept Invitation
     */
    acceptRoomInvitation(roomSid, invitationSid, streemApiAcceptRoomInvitationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acceptRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiAcceptRoomInvitationRequest: streemApiAcceptRoomInvitationRequest });
            return yield response.value();
        });
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete
     */
    archiveAndDeleteRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling archiveAndDeleteRoom.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/archive-and-delete`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete
     */
    archiveAndDeleteRoom(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.archiveAndDeleteRoomRaw({ roomSid: roomSid });
        });
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete along with the caller (non-expert)
     */
    archiveAndDeleteRoomAndDeleteNonExpertParticipantRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling archiveAndDeleteRoomAndDeleteNonExpertParticipant.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/~archive-and-delete`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiArchiveAndDeleteRoomResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete along with the caller (non-expert)
     */
    archiveAndDeleteRoomAndDeleteNonExpertParticipant(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.archiveAndDeleteRoomAndDeleteNonExpertParticipantRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Mark invitation as cancelled (by inviter)
     * Cancel Invitation
     */
    cancelRoomInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling cancelRoomInvitation.');
            }
            if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
                throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling cancelRoomInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/cancel`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCancelRoomInvitationRequestToJSON)(requestParameters.streemApiCancelRoomInvitationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCancelRoomInvitationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Mark invitation as cancelled (by inviter)
     * Cancel Invitation
     */
    cancelRoomInvitation(roomSid, invitationSid, streemApiCancelRoomInvitationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cancelRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiCancelRoomInvitationRequest: streemApiCancelRoomInvitationRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new token to use to connect to a Room with readonly privileges
     * Create Readonly Token
     */
    createReadonlyRoomTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createReadonlyRoomToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/readonly-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateReadonlyRoomTokenResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new token to use to connect to a Room with readonly privileges
     * Create Readonly Token
     */
    createReadonlyRoomToken(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createReadonlyRoomTokenRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Create a new Streem Room
     * Create Room
     */
    createRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateRoomRequestToJSON)(requestParameters.streemApiCreateRoomRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new Streem Room
     * Create Room
     */
    createRoom(streemApiCreateRoomRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomRaw({ streemApiCreateRoomRequest: streemApiCreateRoomRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new Room Invitation, which allows the invited User to have access to the Room
     * Create Room Invitation
     */
    createRoomInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/invitations`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateRoomInvitationRequestToJSON)(requestParameters.streemApiCreateRoomInvitationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomInvitationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new Room Invitation, which allows the invited User to have access to the Room
     * Create Room Invitation
     */
    createRoomInvitation(roomSid, streemApiCreateRoomInvitationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomInvitationRaw({ roomSid: roomSid, streemApiCreateRoomInvitationRequest: streemApiCreateRoomInvitationRequest });
            return yield response.value();
        });
    }
    /**
     * Create Room Outcome Report artifact for this Room
     * Create Room Outcome Report
     */
    createRoomOutcomeReportRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomOutcomeReport.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateRoomOutcomeReportRequestToJSON)(requestParameters.streemApiCreateRoomOutcomeReportRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomOutcomeReportResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create Room Outcome Report artifact for this Room
     * Create Room Outcome Report
     */
    createRoomOutcomeReport(roomSid, streemApiCreateRoomOutcomeReportRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomOutcomeReportRaw({ roomSid: roomSid, streemApiCreateRoomOutcomeReportRequest: streemApiCreateRoomOutcomeReportRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new ON_DEVICE Recording for a room
     * Create Recording
     */
    createRoomRecordingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomRecording.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/recordings`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRecordingResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new ON_DEVICE Recording for a room
     * Create Recording
     */
    createRoomRecording(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomRecordingRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Create a new Share Token, which can be provided as `Authorization: ShareToken [token]` to gain readonly access to the Room
     * Create Share Token
     */
    createRoomShareTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomShareToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/share-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateRoomShareTokenRequestToJSON)(requestParameters.streemApiCreateRoomShareTokenRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomShareTokenResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new Share Token, which can be provided as `Authorization: ShareToken [token]` to gain readonly access to the Room
     * Create Share Token
     */
    createRoomShareToken(roomSid, streemApiCreateRoomShareTokenRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomShareTokenRaw({ roomSid: roomSid, streemApiCreateRoomShareTokenRequest: streemApiCreateRoomShareTokenRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new wall/video token to use to connect to a Room as a User
     * Create wall/video Token
     */
    createRoomTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomToken.');
            }
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomToken.');
            }
            const queryParameters = {};
            if (requestParameters.preflight !== undefined) {
                queryParameters['preflight'] = requestParameters.preflight;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/participants/{user_sid}/tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomTokenResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new wall/video token to use to connect to a Room as a User
     * Create wall/video Token
     */
    createRoomToken(roomSid, userSid, preflight) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomTokenRaw({ roomSid: roomSid, userSid: userSid, preflight: preflight });
            return yield response.value();
        });
    }
    /**
     * Create new credentials to use to connect to a Room as a User
     * Create Video credentials
     */
    createRoomVideoCredentialsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomVideoCredentials.');
            }
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomVideoCredentials.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/participants/{user_sid}/credentials/video`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateRoomVideoCredentialsRequestToJSON)(requestParameters.streemApiCreateRoomVideoCredentialsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomVideoCredentialsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create new credentials to use to connect to a Room as a User
     * Create Video credentials
     */
    createRoomVideoCredentials(roomSid, userSid, streemApiCreateRoomVideoCredentialsRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomVideoCredentialsRaw({ roomSid: roomSid, userSid: userSid, streemApiCreateRoomVideoCredentialsRequest: streemApiCreateRoomVideoCredentialsRequest });
            return yield response.value();
        });
    }
    /**
     * Create new wall credentials to use to connect/update the room wall
     * Create wall credentials
     */
    createRoomWallCredentialsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomWallCredentials.');
            }
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomWallCredentials.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/participants/{user_sid}/credentials/wall`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateRoomWallCredentialsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create new wall credentials to use to connect/update the room wall
     * Create wall credentials
     */
    createRoomWallCredentials(roomSid, userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRoomWallCredentialsRaw({ roomSid: roomSid, userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * Create a new streemshot request
     * Create Streemshot Request
     */
    createStreemshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createStreemshot.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling createStreemshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/request`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateStreemshotRequestToJSON)(requestParameters.streemApiCreateStreemshotRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateStreemshotResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new streemshot request
     * Create Streemshot Request
     */
    createStreemshot(roomSid, streemshotSid, streemApiCreateStreemshotRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiCreateStreemshotRequest: streemApiCreateStreemshotRequest });
            return yield response.value();
        });
    }
    /**
     * Create a streemshot revision, which may include new AR data
     * Create Streemshot Revision
     */
    createStreemshotRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createStreemshotRevision.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling createStreemshotRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/revisions`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateStreemshotRevisionRequestToJSON)(requestParameters.streemApiCreateStreemshotRevisionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateStreemshotRevisionResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a streemshot revision, which may include new AR data
     * Create Streemshot Revision
     */
    createStreemshotRevision(roomSid, streemshotSid, streemApiCreateStreemshotRevisionRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createStreemshotRevisionRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiCreateStreemshotRevisionRequest: streemApiCreateStreemshotRevisionRequest });
            return yield response.value();
        });
    }
    /**
     * Delete a video recording bookmark
     * Delete Bookmark
     */
    deleteBookmarkRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteBookmark.');
            }
            if (requestParameters.bookmarkSid === null || requestParameters.bookmarkSid === undefined) {
                throw new runtime.RequiredError('bookmarkSid', 'Required parameter requestParameters.bookmarkSid was null or undefined when calling deleteBookmark.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/bookmarks/{bookmark_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"bookmark_sid"}}`, encodeURIComponent(String(requestParameters.bookmarkSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a video recording bookmark
     * Delete Bookmark
     */
    deleteBookmark(roomSid, bookmarkSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteBookmarkRaw({ roomSid: roomSid, bookmarkSid: bookmarkSid });
        });
    }
    /**
     * Delete external audio recording and revert original Streem-recorded audio
     * Delete external audio
     */
    deleteExternalAudioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteExternalAudio.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/artifacts/external-audio`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete external audio recording and revert original Streem-recorded audio
     * Delete external audio
     */
    deleteExternalAudio(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteExternalAudioRaw({ roomSid: roomSid });
        });
    }
    /**
     * Delete the specified GPS position
     * Delete GPS
     */
    deleteGpsPositionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteGpsPosition.');
            }
            if (requestParameters.gpsPositionSid === null || requestParameters.gpsPositionSid === undefined) {
                throw new runtime.RequiredError('gpsPositionSid', 'Required parameter requestParameters.gpsPositionSid was null or undefined when calling deleteGpsPosition.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/gps-positions/{gps_position_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"gps_position_sid"}}`, encodeURIComponent(String(requestParameters.gpsPositionSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete the specified GPS position
     * Delete GPS
     */
    deleteGpsPosition(roomSid, gpsPositionSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteGpsPositionRaw({ roomSid: roomSid, gpsPositionSid: gpsPositionSid });
        });
    }
    /**
     * Delete a layout estimation
     * Delete Layout Estimation
     */
    deleteLayoutEstimationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteLayoutEstimation.');
            }
            if (requestParameters.layoutEstimationSid === null || requestParameters.layoutEstimationSid === undefined) {
                throw new runtime.RequiredError('layoutEstimationSid', 'Required parameter requestParameters.layoutEstimationSid was null or undefined when calling deleteLayoutEstimation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/layout-estimations/{layout_estimation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"layout_estimation_sid"}}`, encodeURIComponent(String(requestParameters.layoutEstimationSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a layout estimation
     * Delete Layout Estimation
     */
    deleteLayoutEstimation(roomSid, layoutEstimationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteLayoutEstimationRaw({ roomSid: roomSid, layoutEstimationSid: layoutEstimationSid });
        });
    }
    /**
     * Delete a mesh
     * Delete Mesh
     */
    deleteMeshRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteMesh.');
            }
            if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
                throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling deleteMesh.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a mesh
     * Delete Mesh
     */
    deleteMesh(roomSid, meshSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteMeshRaw({ roomSid: roomSid, meshSid: meshSid });
        });
    }
    /**
     * Delete a Recording artifact, which will eventually permanently remove it from storage
     * Delete Recording
     */
    deleteRecordingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRecording.');
            }
            if (requestParameters.recordingSid === null || requestParameters.recordingSid === undefined) {
                throw new runtime.RequiredError('recordingSid', 'Required parameter requestParameters.recordingSid was null or undefined when calling deleteRecording.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/recordings/{recording_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"recording_sid"}}`, encodeURIComponent(String(requestParameters.recordingSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a Recording artifact, which will eventually permanently remove it from storage
     * Delete Recording
     */
    deleteRecording(roomSid, recordingSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRecordingRaw({ roomSid: roomSid, recordingSid: recordingSid });
        });
    }
    /**
     * Delete the Room, which deletes all Assets from storage, and hides from Call Logs
     * Delete Room
     */
    deleteRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoom.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete the Room, which deletes all Assets from storage, and hides from Call Logs
     * Delete Room
     */
    deleteRoom(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRoomRaw({ roomSid: roomSid });
        });
    }
    /**
     * Delete the Note from the specified Room
     * Delete Room Note
     */
    deleteRoomNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoomNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete the Note from the specified Room
     * Delete Room Note
     */
    deleteRoomNote(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRoomNoteRaw({ roomSid: roomSid });
        });
    }
    /**
     * Delete Room Outcome Report artifact for this Room
     * Delete Room Outcome Report
     */
    deleteRoomOutcomeReportRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoomOutcomeReport.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete Room Outcome Report artifact for this Room
     * Delete Room Outcome Report
     */
    deleteRoomOutcomeReport(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRoomOutcomeReportRaw({ roomSid: roomSid });
        });
    }
    /**
     * Delete a sceneshot
     * Delete Sceneshot
     */
    deleteSceneshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteSceneshot.');
            }
            if (requestParameters.sceneshotSid === null || requestParameters.sceneshotSid === undefined) {
                throw new runtime.RequiredError('sceneshotSid', 'Required parameter requestParameters.sceneshotSid was null or undefined when calling deleteSceneshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/sceneshots/{sceneshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"sceneshot_sid"}}`, encodeURIComponent(String(requestParameters.sceneshotSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a sceneshot
     * Delete Sceneshot
     */
    deleteSceneshot(roomSid, sceneshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteSceneshotRaw({ roomSid: roomSid, sceneshotSid: sceneshotSid });
        });
    }
    /**
     * Delete a Streemshot, which will eventually permanently remove it from storage
     * Delete Streemshot
     */
    deleteStreemshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteStreemshot.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling deleteStreemshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a Streemshot, which will eventually permanently remove it from storage
     * Delete Streemshot
     */
    deleteStreemshot(roomSid, streemshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
        });
    }
    /**
     * Delete the text Note from a Streemshot
     * Delete Streemshot Note
     */
    deleteStreemshotNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteStreemshotNote.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling deleteStreemshotNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete the text Note from a Streemshot
     * Delete Streemshot Note
     */
    deleteStreemshotNote(roomSid, streemshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
        });
    }
    /**
     * Delete a textured mesh
     * Delete Textured Mesh
     */
    deleteTexturedMeshRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteTexturedMesh.');
            }
            if (requestParameters.texturedMeshSid === null || requestParameters.texturedMeshSid === undefined) {
                throw new runtime.RequiredError('texturedMeshSid', 'Required parameter requestParameters.texturedMeshSid was null or undefined when calling deleteTexturedMesh.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/textured-meshes/{textured_mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"textured_mesh_sid"}}`, encodeURIComponent(String(requestParameters.texturedMeshSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Delete a textured mesh
     * Delete Textured Mesh
     */
    deleteTexturedMesh(roomSid, texturedMeshSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTexturedMeshRaw({ roomSid: roomSid, texturedMeshSid: texturedMeshSid });
            return yield response.value();
        });
    }
    /**
     * Finalize the note for the specified Room
     * Finalize Room Note
     */
    finalizeRoomNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling finalizeRoomNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/note/~finalize`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiFinalizeRoomNoteResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Finalize the note for the specified Room
     * Finalize Room Note
     */
    finalizeRoomNote(roomSid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.finalizeRoomNoteRaw({ roomSid: roomSid, body: body });
            return yield response.value();
        });
    }
    /**
     * Fulfill a mesh request
     * Fulfill Mesh Request
     */
    fulfillMeshRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillMesh.');
            }
            if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
                throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling fulfillMesh.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiFulfillMeshResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Fulfill a mesh request
     * Fulfill Mesh Request
     */
    fulfillMesh(roomSid, meshSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fulfillMeshRaw({ roomSid: roomSid, meshSid: meshSid });
            return yield response.value();
        });
    }
    /**
     * Fulfill a Recording artifact after upload is complete
     * Fulfill Recording
     */
    fulfillRecordingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillRecording.');
            }
            if (requestParameters.recordingSid === null || requestParameters.recordingSid === undefined) {
                throw new runtime.RequiredError('recordingSid', 'Required parameter requestParameters.recordingSid was null or undefined when calling fulfillRecording.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/recordings/{recording_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"recording_sid"}}`, encodeURIComponent(String(requestParameters.recordingSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiFulfillRecordingRequestToJSON)(requestParameters.streemApiFulfillRecordingRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiFulfillRecordingResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Fulfill a Recording artifact after upload is complete
     * Fulfill Recording
     */
    fulfillRecording(roomSid, recordingSid, streemApiFulfillRecordingRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fulfillRecordingRaw({ roomSid: roomSid, recordingSid: recordingSid, streemApiFulfillRecordingRequest: streemApiFulfillRecordingRequest });
            return yield response.value();
        });
    }
    /**
     * Fulfill a streemshot request
     * Fulfill Streemshot Request
     */
    fulfillStreemshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillStreemshot.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling fulfillStreemshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiFulfillStreemshotRequestToJSON)(requestParameters.streemApiFulfillStreemshotRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiFulfillStreemshotResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Fulfill a streemshot request
     * Fulfill Streemshot Request
     */
    fulfillStreemshot(roomSid, streemshotSid, streemApiFulfillStreemshotRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fulfillStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiFulfillStreemshotRequest: streemApiFulfillStreemshotRequest });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified video recording bookmark
     * Get Bookmark
     */
    getBookmarkRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getBookmark.');
            }
            if (requestParameters.bookmarkSid === null || requestParameters.bookmarkSid === undefined) {
                throw new runtime.RequiredError('bookmarkSid', 'Required parameter requestParameters.bookmarkSid was null or undefined when calling getBookmark.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/bookmarks/{bookmark_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"bookmark_sid"}}`, encodeURIComponent(String(requestParameters.bookmarkSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetBookmarkResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified video recording bookmark
     * Get Bookmark
     */
    getBookmark(roomSid, bookmarkSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBookmarkRaw({ roomSid: roomSid, bookmarkSid: bookmarkSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified GPS position
     * Get GPS
     */
    getGpsPositionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getGpsPosition.');
            }
            if (requestParameters.gpsPositionSid === null || requestParameters.gpsPositionSid === undefined) {
                throw new runtime.RequiredError('gpsPositionSid', 'Required parameter requestParameters.gpsPositionSid was null or undefined when calling getGpsPosition.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/gps-positions/{gps_position_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"gps_position_sid"}}`, encodeURIComponent(String(requestParameters.gpsPositionSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGpsPositionResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified GPS position
     * Get GPS
     */
    getGpsPosition(roomSid, gpsPositionSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGpsPositionRaw({ roomSid: roomSid, gpsPositionSid: gpsPositionSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified layout estimation
     * Get Layout Estimation
     */
    getLayoutEstimationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getLayoutEstimation.');
            }
            if (requestParameters.layoutEstimationSid === null || requestParameters.layoutEstimationSid === undefined) {
                throw new runtime.RequiredError('layoutEstimationSid', 'Required parameter requestParameters.layoutEstimationSid was null or undefined when calling getLayoutEstimation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/layout-estimations/{layout_estimation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"layout_estimation_sid"}}`, encodeURIComponent(String(requestParameters.layoutEstimationSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetLayoutEstimationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified layout estimation
     * Get Layout Estimation
     */
    getLayoutEstimation(roomSid, layoutEstimationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLayoutEstimationRaw({ roomSid: roomSid, layoutEstimationSid: layoutEstimationSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified mesh
     * Get Mesh
     */
    getMeshRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getMesh.');
            }
            if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
                throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling getMesh.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetMeshResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified mesh
     * Get Mesh
     */
    getMesh(roomSid, meshSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMeshRaw({ roomSid: roomSid, meshSid: meshSid });
            return yield response.value();
        });
    }
    /**
     * Get information about the specified Room
     * Get Room
     */
    getRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoom.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get information about the specified Room
     * Get Room
     */
    getRoom(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Get the Call Log Entry for this Room and User
     * Get Call Log Entry
     */
    getRoomCallLogEntryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomCallLogEntry.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/call-log-entry`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomCallLogEntryResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the Call Log Entry for this Room and User
     * Get Call Log Entry
     */
    getRoomCallLogEntry(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomCallLogEntryRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Get information for the specified invitation within this Room
     * Get Room Invitation
     */
    getRoomInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomInvitation.');
            }
            if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
                throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling getRoomInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiRoomInvitationFromJSON)(jsonValue));
        });
    }
    /**
     * Get information for the specified invitation within this Room
     * Get Room Invitation
     */
    getRoomInvitation(roomSid, invitationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid });
            return yield response.value();
        });
    }
    /**
     * Gets the text Note for the specified Room
     * Get Room Note
     */
    getRoomNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomNoteResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Gets the text Note for the specified Room
     * Get Room Note
     */
    getRoomNote(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomNoteRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Get Room Outcome Report artifact for this Room
     * Get Room Outcome Report
     */
    getRoomOutcomeReportRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomOutcomeReport.');
            }
            if (requestParameters.roomOutcomeReportSid === null || requestParameters.roomOutcomeReportSid === undefined) {
                throw new runtime.RequiredError('roomOutcomeReportSid', 'Required parameter requestParameters.roomOutcomeReportSid was null or undefined when calling getRoomOutcomeReport.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/outcome-reports/{room_outcome_report_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"room_outcome_report_sid"}}`, encodeURIComponent(String(requestParameters.roomOutcomeReportSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomOutcomeReportResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get Room Outcome Report artifact for this Room
     * Get Room Outcome Report
     */
    getRoomOutcomeReport(roomSid, roomOutcomeReportSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomOutcomeReportRaw({ roomSid: roomSid, roomOutcomeReportSid: roomOutcomeReportSid });
            return yield response.value();
        });
    }
    /**
     * Get a Share Token by `token_sid`
     * Get Share Token
     */
    getRoomShareTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomShareToken.');
            }
            if (requestParameters.tokenSid === null || requestParameters.tokenSid === undefined) {
                throw new runtime.RequiredError('tokenSid', 'Required parameter requestParameters.tokenSid was null or undefined when calling getRoomShareToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/share-tokens/{token_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"token_sid"}}`, encodeURIComponent(String(requestParameters.tokenSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomShareTokenResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a Share Token by `token_sid`
     * Get Share Token
     */
    getRoomShareToken(roomSid, tokenSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomShareTokenRaw({ roomSid: roomSid, tokenSid: tokenSid });
            return yield response.value();
        });
    }
    /**
     * Gets all room wall items and decrypts if necessary. This is an admin endpoint for manual testing. Do not use in code.
     * Get Wall Items
     */
    getRoomWallItemsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomWallItems.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/wall-items`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetRoomWallItemsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Gets all room wall items and decrypts if necessary. This is an admin endpoint for manual testing. Do not use in code.
     * Get Wall Items
     */
    getRoomWallItems(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomWallItemsRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified sceneshot
     * Get Sceneshot
     */
    getSceneshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getSceneshot.');
            }
            if (requestParameters.sceneshotSid === null || requestParameters.sceneshotSid === undefined) {
                throw new runtime.RequiredError('sceneshotSid', 'Required parameter requestParameters.sceneshotSid was null or undefined when calling getSceneshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/sceneshots/{sceneshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"sceneshot_sid"}}`, encodeURIComponent(String(requestParameters.sceneshotSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetSceneshotResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified sceneshot
     * Get Sceneshot
     */
    getSceneshot(roomSid, sceneshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSceneshotRaw({ roomSid: roomSid, sceneshotSid: sceneshotSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified Streemshot
     * Get Streemshot
     */
    getStreemshotRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getStreemshot.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling getStreemshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetStreemshotResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified Streemshot
     * Get Streemshot
     */
    getStreemshot(roomSid, streemshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
            return yield response.value();
        });
    }
    /**
     * Get the text Note on an existing Streemshot
     * Get Streemshot Note
     */
    getStreemshotNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getStreemshotNote.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling getStreemshotNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetStreemshotNoteResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the text Note on an existing Streemshot
     * Get Streemshot Note
     */
    getStreemshotNote(roomSid, streemshotSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
            return yield response.value();
        });
    }
    /**
     * Get info about the specified textured mesh
     * Get Textured Mesh
     */
    getTexturedMeshRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getTexturedMesh.');
            }
            if (requestParameters.texturedMeshSid === null || requestParameters.texturedMeshSid === undefined) {
                throw new runtime.RequiredError('texturedMeshSid', 'Required parameter requestParameters.texturedMeshSid was null or undefined when calling getTexturedMesh.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/textured-meshes/{textured_mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"textured_mesh_sid"}}`, encodeURIComponent(String(requestParameters.texturedMeshSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetTexturedMeshResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info about the specified textured mesh
     * Get Textured Mesh
     */
    getTexturedMesh(roomSid, texturedMeshSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTexturedMeshRaw({ roomSid: roomSid, texturedMeshSid: texturedMeshSid });
            return yield response.value();
        });
    }
    /**
     * Leaves the Room, which may close the Room if this is the last Participant
     * Leave Room
     */
    leaveRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling leaveRoom.');
            }
            if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
                throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling leaveRoom.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/participants/{user_sid}/leave`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiLeaveRoomResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Leaves the Room, which may close the Room if this is the last Participant
     * Leave Room
     */
    leaveRoom(roomSid, userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.leaveRoomRaw({ roomSid: roomSid, userSid: userSid });
            return yield response.value();
        });
    }
    /**
     * List all GPS positions for the Room
     * List GPS
     */
    listGpsPositionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listGpsPositions.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/gps-positions`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGpsPositionsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all GPS positions for the Room
     * List GPS
     */
    listGpsPositions(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGpsPositionsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all Meshes for this Room
     * List Meshes
     */
    listMeshesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listMeshes.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/meshes`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListMeshesResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Meshes for this Room
     * List Meshes
     */
    listMeshes(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listMeshesRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all Recording artifacts for this Room
     * List Recordings
     */
    listRecordingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRecordings.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/recordings`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRecordingsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Recording artifacts for this Room
     * List Recordings
     */
    listRecordings(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRecordingsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all Artifacts for this Room, such as Recordings, Streemshots, etc.
     * List Artifacts
     */
    listRoomArtifactsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomArtifacts.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/artifacts`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRoomArtifactsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Artifacts for this Room, such as Recordings, Streemshots, etc.
     * List Artifacts
     */
    listRoomArtifacts(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoomArtifactsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all RoomOutcomeReports for this Room
     * List RoomOutcomeReports
     */
    listRoomOutcomeReportsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomOutcomeReports.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRoomOutcomeReportsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all RoomOutcomeReports for this Room
     * List RoomOutcomeReports
     */
    listRoomOutcomeReports(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoomOutcomeReportsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Get the list of Participants for a Room
     * List Participants
     */
    listRoomParticipantsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomParticipants.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/participants`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRoomParticipantsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the list of Participants for a Room
     * List Participants
     */
    listRoomParticipants(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoomParticipantsRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * List Share Tokens for this Room, which give readonly access to the Assets of the Room
     * List Share Tokens
     */
    listRoomShareTokensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomShareTokens.');
            }
            const queryParameters = {};
            if (requestParameters.includeExpired !== undefined) {
                queryParameters['include_expired'] = requestParameters.includeExpired;
            }
            if (requestParameters.expires !== undefined) {
                queryParameters['expires'] = requestParameters.expires;
            }
            if (requestParameters.view !== undefined) {
                queryParameters['view'] = requestParameters.view;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/share-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRoomShareTokensResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List Share Tokens for this Room, which give readonly access to the Assets of the Room
     * List Share Tokens
     */
    listRoomShareTokens(roomSid, includeExpired, expires, view, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoomShareTokensRaw({ roomSid: roomSid, includeExpired: includeExpired, expires: expires, view: view, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List Rooms by various filters.  You must provide the `company_sid` param at a minimum.
     * List Rooms
     */
    listRoomsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.createdByUserSid !== undefined) {
                queryParameters['created_by_user_sid'] = requestParameters.createdByUserSid;
            }
            if (requestParameters.companySid !== undefined) {
                queryParameters['company_sid'] = requestParameters.companySid;
            }
            if (requestParameters.referenceId !== undefined) {
                queryParameters['reference_id'] = requestParameters.referenceId;
            }
            if (requestParameters.integrationId !== undefined) {
                queryParameters['integration_id'] = requestParameters.integrationId;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListRoomsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List Rooms by various filters.  You must provide the `company_sid` param at a minimum.
     * List Rooms
     */
    listRooms(createdByUserSid, companySid, referenceId, integrationId, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoomsRaw({ createdByUserSid: createdByUserSid, companySid: companySid, referenceId: referenceId, integrationId: integrationId, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all Sceneshots for this Room
     * List Sceneshots
     */
    listSceneshotsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listSceneshots.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/sceneshots`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListSceneshotsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Sceneshots for this Room
     * List Sceneshots
     */
    listSceneshots(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listSceneshotsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List all Streemshot Artifacts for this Room
     * List Streemshots
     */
    listStreemshotsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listStreemshots.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListStreemshotsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Streemshot Artifacts for this Room
     * List Streemshots
     */
    listStreemshots(roomSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listStreemshotsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Pause an ongiong twilio recording, which will stop recording until resume request is received
     * Pause Recording
     */
    pauseRoomRecordingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling pauseRoomRecording.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/~pause-recording`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Pause an ongiong twilio recording, which will stop recording until resume request is received
     * Pause Recording
     */
    pauseRoomRecording(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.pauseRoomRecordingRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Mark invitation as rejected (by invitee)
     * Reject Invitation
     */
    rejectRoomInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling rejectRoomInvitation.');
            }
            if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
                throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling rejectRoomInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/reject`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiRejectRoomInvitationRequestToJSON)(requestParameters.streemApiRejectRoomInvitationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiRejectRoomInvitationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Mark invitation as rejected (by invitee)
     * Reject Invitation
     */
    rejectRoomInvitation(roomSid, invitationSid, streemApiRejectRoomInvitationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.rejectRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiRejectRoomInvitationRequest: streemApiRejectRoomInvitationRequest });
            return yield response.value();
        });
    }
    /**
     * Resume a recording, which will continue recording until pause request is received
     * Resume Recording
     */
    resumeRoomRecordingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling resumeRoomRecording.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/~resume-recording`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Resume a recording, which will continue recording until pause request is received
     * Resume Recording
     */
    resumeRoomRecording(roomSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resumeRoomRecordingRaw({ roomSid: roomSid });
            return yield response.value();
        });
    }
    /**
     * Revoke a Share Token, which sets its `expires_at` value to now
     * Revoke Share Token
     */
    revokeRoomShareTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling revokeRoomShareToken.');
            }
            if (requestParameters.tokenSid === null || requestParameters.tokenSid === undefined) {
                throw new runtime.RequiredError('tokenSid', 'Required parameter requestParameters.tokenSid was null or undefined when calling revokeRoomShareToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/share-tokens/{token_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"token_sid"}}`, encodeURIComponent(String(requestParameters.tokenSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Revoke a Share Token, which sets its `expires_at` value to now
     * Revoke Share Token
     */
    revokeRoomShareToken(roomSid, tokenSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.revokeRoomShareTokenRaw({ roomSid: roomSid, tokenSid: tokenSid });
        });
    }
    /**
     * Update the room
     * Update room
     */
    updateRoomRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateRoom.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateRoomRequestToJSON)(requestParameters.streemApiUpdateRoomRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateRoomResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the room
     * Update room
     */
    updateRoom(roomSid, streemApiUpdateRoomRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateRoomRaw({ roomSid: roomSid, streemApiUpdateRoomRequest: streemApiUpdateRoomRequest });
            return yield response.value();
        });
    }
    /**
     * Updates the text Note for the specified Room
     * Update Room Note
     */
    updateRoomNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateRoomNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateRoomNoteRequestToJSON)(requestParameters.streemApiUpdateRoomNoteRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateRoomNoteResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates the text Note for the specified Room
     * Update Room Note
     */
    updateRoomNote(roomSid, streemApiUpdateRoomNoteRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateRoomNoteRaw({ roomSid: roomSid, streemApiUpdateRoomNoteRequest: streemApiUpdateRoomNoteRequest });
            return yield response.value();
        });
    }
    /**
     * Update the text Note on an existing Streemshot
     * Update Streemshot Note
     */
    updateStreemshotNoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
                throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateStreemshotNote.');
            }
            if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
                throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling updateStreemshotNote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateStreemshotNoteRequestToJSON)(requestParameters.streemApiUpdateStreemshotNoteRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateStreemshotNoteResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the text Note on an existing Streemshot
     * Update Streemshot Note
     */
    updateStreemshotNote(roomSid, streemshotSid, streemApiUpdateStreemshotNoteRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiUpdateStreemshotNoteRequest: streemApiUpdateStreemshotNoteRequest });
            return yield response.value();
        });
    }
}
exports.RoomsApi = RoomsApi;
/**
    * @export
    * @enum {string}
    */
var ListRoomShareTokensExpires;
(function (ListRoomShareTokensExpires) {
    ListRoomShareTokensExpires["ANY"] = "EXPIRES_ANY";
    ListRoomShareTokensExpires["NO"] = "EXPIRES_NO";
    ListRoomShareTokensExpires["YES"] = "EXPIRES_YES";
})(ListRoomShareTokensExpires = exports.ListRoomShareTokensExpires || (exports.ListRoomShareTokensExpires = {}));
/**
    * @export
    * @enum {string}
    */
var ListRoomShareTokensView;
(function (ListRoomShareTokensView) {
    ListRoomShareTokensView["BASIC"] = "VIEW_BASIC";
    ListRoomShareTokensView["FULL"] = "VIEW_FULL";
    ListRoomShareTokensView["INVALID"] = "VIEW_INVALID";
})(ListRoomShareTokensView = exports.ListRoomShareTokensView || (exports.ListRoomShareTokensView = {}));
//# sourceMappingURL=RoomsApi.js.map